interface Plan {
  name: string;
  price: string;
  note: string;
  features: string[];
  featured: boolean;
}

const plans: Plan[] = [
  {
    name: 'Trial',
    price: 'Free',
    note: 'Operator-subsidised',
    features: [
      '32K context window',
      'Unlimited tokens',
      'Chat + Agent Mode',
      'Persistent memory',
      'Shared GPU capacity',
    ],
    featured: false,
  },
  {
    name: 'Base',
    price: '$1',
    note: 'per active hour',
    features: [
      '100K context window',
      'Unlimited tokens',
      'Chat + Agent Mode',
      'Persistent memory',
      'Shared GPU capacity',
      'Priority resource allocation',
    ],
    featured: true,
  },
];

function Pricing() {
  return (
    <section class="section" id="pricing">
      <div class="container">
        <div class="section-header">
          <div class="flex items-center justify-center gap-2.5 flex-wrap">
            <span class="tag">Pricing</span>
            <span class="inline-block font-mono text-[0.7rem] tracking-[0.08em] uppercase text-[oklch(70%_0.14_85)] border border-[oklch(70%_0.14_85/_0.4)] rounded-full px-[0.75em] py-[0.25em] bg-[oklch(70%_0.14_85/_0.08)]">
              Coming soon
            </span>
          </div>
          <h2>Pay for GPU time, not tokens</h2>
        </div>
        <p class="text-center text-muted max-w-[560px] mx-auto mb-10 text-[0.95rem]">
          You're not paying for AI access — you're paying for the GPU time your session
          uses. No per-token charges, no message limits. You pick a tier; the model is
          handled for you.
        </p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[700px] mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              class={`relative p-8 text-center glass transition-[border-color] duration-300 ${
                plan.featured
                  ? 'border-accent shadow-[0_0_30px_var(--accent-glow)]'
                  : 'hover:border-accent-dim'
              }`}
            >
              <div class="font-mono text-[0.7rem] uppercase tracking-[0.15em] text-accent mb-2">
                {plan.name}
              </div>
              <div class="font-display text-[2.5rem] font-extrabold tracking-[-0.02em] mb-1">
                {plan.price}
              </div>
              <div class="text-[0.85rem] text-muted mb-5">{plan.note}</div>
              <ul class="list-none text-left text-[0.875rem] text-muted">
                {plan.features.map((feat) => (
                  <li key={feat} class="relative pl-5 py-1.5">
                    <span class="absolute left-0 text-check font-bold">✓</span>
                    {feat}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p class="text-center mt-6 text-[0.85rem] text-muted max-w-[560px] mx-auto">
          You only pay while your session holds a live GPU slot — never per token.
          Multiple users share GPU capacity, so the more concurrent users, the lower
          the cost per person. Rates shown are launch targets.
        </p>
      </div>
    </section>
  );
}

export default Pricing;
